import React from 'react'
import { fetchAccessToken, fetchLoginInfoFromServer } from '../login.service'
import makeAsyncScriptLoader from 'react-async-script'
import styles from '../../styles.module.css'
import { Loader } from '../../Components/loader/loaderView'
import { MessageType, messages } from '../constant'
import { NotificationComponent } from '../../Components/notificationWrapper/notificationWrapper'
class GoogleLoginComponent extends React.Component {
  constructor(props) {
    super(props)
    window.GoogleLoginComponent = this
    window.client = this.client
    this.state = {
      loading: false
    }
  }

  onLoginSuccess = (res) => {
    if (res.code) {
      this.setState({
        loading: true
      })
      fetchLoginInfoFromServer(res.code)
        .then((response) => {
          if (response.data && response.data.status !== 'UNAUTHORIZED') {
            fetchAccessToken(response.data.username, response.data.password)
              .then((response) => {
                if (response) {
                  this.setState({
                    loading: false
                  })
                  this.props.onLoginSuccess(response)
                }
              })
              .catch((err) => {
                this.setState({
                  loading: false
                })
                this._addNotification(
                  MessageType.ERROR,
                  err.response.data.error_description ||
                    err.response.data.message
                )
              })
          } else {
            this.setState({
              loading: false
            })
            this._addNotification(MessageType.ERROR, response)
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })

          this._addNotification(
            MessageType.ERROR,
            err.response.data.error_description ||
              err.response.data.message ||
              err.error_description ||
              err.message ||
              messages.user_info_error
          )
        })
    } else {
      this.setState({
        loading: false
      })
      this._addNotification(MessageType.ERROR, messages.google_code_error)
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  /**
   * Used to show Notifications
   * @param  type Type of Notification
   * @param  msg   Message to Show
   */
  _addNotification(type, msg) {
    this._notificationSystem._addNotification(type, msg)
  }

  getAuthCode() {
    // Request authorization code and obtain user consent
    window.client.requestCode()
  }

  render() {
    return (
      <div>
        <Loader loading={this.state.loading} />
        {!this.state.loading && (
          <div>
            <div
              id='customBtn'
              className={styles.google_sign_in_wrapper}
              onClick={() => {
                this.getAuthCode()
              }}
            >
              <div className={styles.google_logo}>
                <span className='icon' />
              </div>
              <span className={styles.google_sign_in_text}>
                Sign in with Google
              </span>
            </div>
          </div>
        )}
        <div>
          <div className=' body-container'>
            <NotificationComponent ref='notificationSystem' />
          </div>
        </div>
      </div>
    )
  }
}
function onLoad() {
  window.client = window.google.accounts.oauth2.initCodeClient({
    client_id: this.googleProperties.auth.client_id,
    scope: 'profile email',
    callback: (response) => {
      window.GoogleLoginComponent.onLoginSuccess(response)
    }
  })
}
const URL = `https://accounts.google.com/gsi/client`

const SignInWrapper = makeAsyncScriptLoader(URL, {
  onLoad: onLoad
})(GoogleLoginComponent)

const AsyncGoogleLoginComponent = (props) => (
  <SignInWrapper {...props} asyncScriptOnLoad={onLoad} />
)

export default AsyncGoogleLoginComponent
